import { ComponentPropsWithoutRef } from "react";
import { ExpandMoreIcon } from "../icons";
import { PaginationTypeProps } from "@/components/data-table/types/pagination-type-props";
import { isDefined } from "@/helper/utils";
import clsx from "clsx";

export const PaginationButton = ({
  disabled,
  className = "",
  ...props
}: ComponentPropsWithoutRef<"button"> & {
  className?: string;
  disabled?: boolean;
}) => (
  <button
    type="button"
    {...props}
    className={clsx(
      "w-[25px] h-[23px] rounded bg-[#E8E8E838] font-medium text-sm text-[#292A2F]",
      "relative inline-flex items-center justify-center py-2 focus:z-10 focus:outline-hidden transition ease-in-out duration-150 border-none",
      !disabled && "active:bg-[#E8E8E8]",
      className,
    )}
  />
);

export const PaginationNumber = ({
  goPrev,
  disablePrev,
  listPage,
  onChangePage,
  currentPage,
  goNext,
  disableNext,
  className,
}: PaginationTypeProps) => {
  const content = (
    <div className="flex">
      <div className="flex flex-wrap justify-between items-center">
        <div className="inline-flex gap-x-3">
          <PaginationButton
            onClick={goPrev}
            className={disablePrev ? "pointer-events-none cursor-not-allowed opacity-30" : ""}
            disabled={disablePrev}
          >
            <span className="sr-only">Previous</span>
            <ExpandMoreIcon className="h-[25px] w-[23px] transform rotate-90" />
          </PaginationButton>
          {listPage.map(({ page, optional }, index) => {
            const nodeKey = listPage[index - 1]?.page + "-" + index;
            return isDefined(page) ? (
              <PaginationButton
                onClick={() => onChangePage(page)}
                className={clsx(
                  optional ? "hidden lg:inline-flex" : "inline-flex",
                  page === currentPage ? classByStatus["selected"] : classByStatus["default"],
                )}
                key={`pagination-number-${nodeKey}`}
              >
                {page}
              </PaginationButton>
            ) : (
              <span
                className="-ml-px relative rounded-lg inline-flex items-center text-sm leading-5 font-bold text-[#292A2F]"
                key={`filler-${nodeKey}`}
              >
                ...
              </span>
            );
          })}
          <PaginationButton
            onClick={goNext}
            className={disableNext ? "pointer-events-none cursor-not-allowed opacity-30" : ""}
            disabled={disableNext}
          >
            <span className="sr-only">Next</span>
            <ExpandMoreIcon className="h-[25px] w-[23px] transform -rotate-90" />
          </PaginationButton>
        </div>
      </div>
    </div>
  );

  return className ? <div className={className}>{content}</div> : content;
};

type status = "default" | "selected";

const classByStatus: Record<NonNullable<status>, string> = {
  default: "bg-secondary font-medium",
  selected: "bg-active font-bold",
};
